import React, { useState } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import fondo from '../style/_assets/img/fondo3.png';
import { loginExternal } from '@/services/authService';
import { useDispatch } from 'react-redux';
import { setUser } from '@/redux/actions/userActions';
import NuevaContrasenaModal from './NuevaContrasenaModal';
import RegistrarModal from './RegistrarModal';

const LoginModal = ({ open, onLoginSuccess }) => {
  const dispatch = useDispatch();
  const [showNuevaContrasena, setShowNuevaContrasena] = useState(false);
  const [showNuevoRegistro, setShowNuevoRegistro] = useState(false);
  const [privacyError, setPrivacyError] = useState('');
  const [document, setDocument] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const handleLogin = async () => {
    setLoginError('');
    setPrivacyError('');

    if (!document.trim()) {
      setLoginError('Debes ingresar tu usuario (usuario)');
      return;
    }

    if (!password.trim()) {
      setLoginError('Debes ingresar tu contraseña');
      return;
    }

    if (!rememberMe) {
      setPrivacyError('Debes aceptar las políticas de privacidad para continuar');
      return;
    }

    try {
      setLoading(true);

      const response = await loginExternal(document, password, rememberMe);

      if (response?.access_token) {
        localStorage.setItem('access_token', response.access_token);
      }

      console.log('VER TODA LA RESPUESTA: ', response);

      dispatch(setUser(response.user ?? response));
      localStorage.setItem('user', JSON.stringify(response.user ?? response));

      localStorage.setItem(
        'auth_data',
        JSON.stringify({
          paciente: response.paciente,
          personal: response.personal,
          token_type: response.token_type,
          expires_at: response.expires_at,
        }),
      );

      setLoading(false);
      onLoginSuccess();
    } catch (error) {
      console.error('ERROR LOGIN:', error);
      setLoading(false);
      setLoginError('Usuario o contraseña incorrectos');
    }
  };

  return (
    <>
      <NuevaContrasenaModal
        open={showNuevaContrasena}
        onBack={() => setShowNuevaContrasena(false)}
      />

      <RegistrarModal open={showNuevoRegistro} onBack={() => setShowNuevoRegistro(false)} />

      <FlexContainer
        className={'pos-fixed justify-center align-items-center '}
        style={{
          inset: 0,
          minHeight: '100vh',
          display: showNuevaContrasena || showNuevoRegistro ? 'none' : 'flex',
          flexDirection: 'column',
          zIndex: 9999,
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `url(${fondo})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            filter: 'blur(5px)',
            zIndex: 1,
          }}
        />
        <div
          style={{
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.65)',
            zIndex: 2,
          }}
        />
        <div
          className={'pos-rel bgBlue400-2'}
          style={{
            borderRadius: '10px',
            padding: '36px',
            color: 'white',
            boxShadow: '0px 4px 20px rgba(0,0,0,0.25)',
            zIndex: 5,
          }}
        >
          <FlexContainer>
            <img
              src="/Logotipo_Centro_Blanco2.png"
              alt="logo"
              style={{ width: '250px', marginBottom: '18px' }}
            />
          </FlexContainer>

          <Label className={'text-16 font-bold'} style={{ color: 'white' }}>
            Accede si ya tienes una cuenta
          </Label>

          <FlexContainer className={'gap-16 margt18'}>
            <label className={'flex-row gap-6 align-center'} style={{ color: 'white' }}>
              <input
                type="radio"
                name="doc"
                defaultChecked
                style={{
                  accentColor: 'black', // Esto hará que el relleno sea negro al seleccionar
                  cursor: 'pointer',
                }}
              />
              DNI
            </label>

            <label className={'flex-row gap-6 align-center'} style={{ color: 'white' }}>
              <input
                type="radio"
                name="doc"
                style={{
                  accentColor: 'black', // Esto hará que el relleno sea negro al seleccionar
                  cursor: 'pointer',
                }}
              />
              CE
            </label>

            <label className={'flex-row gap-6 align-center'} style={{ color: 'white' }}>
              <input
                type="radio"
                name="doc"
                style={{
                  accentColor: 'black', // Esto hará que el relleno sea negro al seleccionar
                  cursor: 'pointer',
                }}
              />
              Pasaporte
            </label>
          </FlexContainer>

          <Label className={'text-14 font-semibold margt18'} style={{ color: 'white' }}>
            Ingresa el Usuario*
          </Label>

          <input
            type="text"
            value={document}
            onChange={(e) => setDocument(e.target.value)}
            className={'padtb10 padlr12 borderrad2 margt4'}
            style={{
              width: '275px',
              border: '1px solid #8DBDFF',
              background: 'white',
              outline: 'none',
              color: '#023B7A',
            }}
            placeholder="Ingresa el usuario"
          />

          <Label className={'text-14 font-semibold margt16 margb4'} style={{ color: 'white' }}>
            Ingresa tu contraseña*
          </Label>

          <FlexContainer className={'pos-rel'} style={{ width: '300px' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={'padtb10 padlr12 borderrad2'}
              style={{
                width: '100%',
                border: '1px solid #8DBDFF',
                background: 'white',
                outline: 'none',
                color: '#023B7A',
              }}
              placeholder="Ingresa la contraseña"
            />

            <span
              className={'pos-abs right10 top8 pointer'}
              style={{ color: '#023b7a' }}
              onClick={() => setShowPassword((prev) => !prev)}
            >
              <i className={`fa-solid ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
            </span>
          </FlexContainer>

          <Label
            className="text-13 margt12 pointer"
            style={{ color: '#86EB66', fontWeight: 600 }}
            onMouseEnter={(e) => (e.target.style.textDecoration = 'underline')}
            onMouseLeave={(e) => (e.target.style.textDecoration = 'none')}
            onClick={() => setShowNuevaContrasena(true)}
          >
            ¿Olvidaste tu contraseña?
          </Label>

          <FlexContainer className={'margt10 text-13'}>
            <input
              type="checkbox"
              className={'margr8'}
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            Acepto las
            <a
              href="/pdf/politicadeprivacidad.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: 4 }}
            >
              {'políticas de privacidad de datos'}
            </a>
          </FlexContainer>

          {privacyError && (
            <Label className="text-12 margt6" style={{ color: '#ffb3b3', fontWeight: 600 }}>
              {privacyError}
            </Label>
          )}
          {loading && (
            <div
              className="borderrad10"
              style={{
                position: 'absolute',
                inset: 0,
                zIndex: 10,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255,255,255,0.6)',
              }}
            >
              <div className="spinner" />
            </div>
          )}

          <FlexContainer className={'justify-center gap-16 margt22'}>
            <button
              onClick={handleLogin}
              className={'padtb12 padlr22 text-12 borderrad18 pointer borderNone'}
              style={{
                background: 'white',
                color: '#023B7A',
                fontWeight: 700,
                minWidth: '120px',
              }}
            >
              INICIAR SESIÓN
            </button>

            <button
              className={'padtb12 padlr22 text-12 borderrad18 pointer'}
              style={{
                background: 'transparent',
                border: '2px solid white',
                color: 'white',
                fontWeight: 600,
                minWidth: '120px',
              }}
              onClick={() => setShowNuevoRegistro(true)}
            >
              REGISTRARSE
            </button>
          </FlexContainer>

          {loginError && (
            <FlexContainer className={'justify-center margt12'}>
              <Label
                className={'text-12'}
                style={{
                  color: '#ffb3b3',
                  fontWeight: 600,
                  textAlign: 'center',
                }}
              >
                {loginError}
              </Label>
            </FlexContainer>
          )}
        </div>
      </FlexContainer>
    </>
  );
};

export default LoginModal;
